/**
 * Dashboard Page Router
 *
 * Routes to the appropriate persona-specific dashboard based on consumer type.
 * Shows a push notification prompt when the user has just submitted an application.
 * Note: Partner dashboards moved to Business Portal
 */

import { PushNotificationPrompt } from '@ops-matrix/design-system-ui';
import { useLocation } from 'react-router-dom';
import { useConsumerType } from '../../contexts/ConsumerTypeContext';
import { usePushNotificationContext } from '../../contexts/PushNotificationContext';
import EndConsumerDashboard from './EndConsumerDashboard';
import LoanApplicantDashboard from './LoanApplicantDashboard';

export default function DashboardPage() {
  const { consumerType } = useConsumerType();
  const location = useLocation();
  const { pushEnabled, requestPermission } = usePushNotificationContext();

  // Show push notification prompt only after application submission
  const state = location.state as { applicationSubmitted?: boolean } | null;
  const showPushPrompt = state?.applicationSubmitted === true;

  return (
    <>
      {showPushPrompt && (
        <PushNotificationPrompt
          entityType="application"
          onEnable={async () => {
            await requestPermission();
          }}
          pushEnabled={pushEnabled}
        />
      )}
      {(() => {
        switch (consumerType) {
          case 'LOAN_APPLICANT':
            return <LoanApplicantDashboard />;
          // CHANNEL_PARTNER, REFERRAL_PARTNER, PARTNER - moved to Business Portal
          case 'END_CONSUMER':
          default:
            return <EndConsumerDashboard />;
        }
      })()}
    </>
  );
}
